
export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: 'var(--label)',
        borderRadius: '0px',
        border: 'none',
        borderBottom: '1px solid var(--border)',
        boxShadow: state.isFocused ? 'none' : provided.boxShadow,
        '&:hover': {
            borderBottom: '1px solid var(--border)',
        }
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'var(--mainTextColor)',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'var(--label)',
    }),
    input: (provided) => ({
        ...provided,
        color: 'var(--mainTextColor)',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? 'var(--primary)'
            : state.isFocused
                ? 'rgba(255, 255, 255, 0.08)'
                : 'var(--darkBG)',
        color: 'var(--mainTextColor)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            color: 'var(--mainTextColor)',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--darkBG)',
        border: '1px solid var(--border)',
        zIndex: 20,
    }),
    menuList: (provided) => ({
        ...provided,
        backgroundColor: 'var(--darkBG)',
    }),
};


